<template>
  <div>
    <AdminMigrationModal
      v-model="dialog"
      :menu-key="menuKey"
      @close="handleClose"
    />
  </div>
</template>

<script>
import AdminMigrationModal from '@/components/AdminMigrationModal.vue';
import {
  getMigratedMenuConfig,
  MIGRATED_MENU_KEYS,
} from '@/helpers/migratedMenus';

export default {
  components: {
    AdminMigrationModal,
  },
  data () {
    return {
      dialog: true,
      menuKey: MIGRATED_MENU_KEYS.FORMS,
    };
  },
  methods: {
    handleClose () {
      const menuConfig = getMigratedMenuConfig(this.menuKey);

      if (this.$route.path === menuConfig.route) {
        this.$router.push({ path: '/dashboard' });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Contents/Facebook/Facebook.vue